import React, { memo, useCallback, useMemo } from 'react';
import { BillsListBloc } from './BillsListBloc';
import { useBloc } from '@core/utils/bloc';
import { formControl, FormDataType, formGroup } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { Tabs, TabsMapping } from '@modules/common';
import { BillsListViaType } from './BillsListViaType';
import { PaymentTypeStatus } from '@business/entities/tm';
import { TimeMaterialService } from '@business/services/time_material_service';
import { useObservable } from '@core/utils/hooks/rxjs';

export const defineBillsFilterForm = () => {
  return formGroup({
    providerId: formControl<string>({ placeholder: 'Select Vendor' }),
    status: formControl<string>({ placeholder: 'Select Status' }),
  });
};

export type BillsFilterFormData = FormDataType<typeof defineBillsFilterForm>;
export type BillsFilterFormType = ReturnType<typeof defineBillsFilterForm>;

export const BillsList = memo(() => {
  const bloc = useBloc(BillsListBloc);
  const form = useMemo(() => defineBillsFilterForm(), []);
  const formValue = useObservable(form.value$);

  const filterTabs: TabsMapping[] = useMemo(() => {
    const tabs = [
      {
        title: 'All',
        component: BillsListViaType,
        props: { type: 'all', bloc },
        visible: true,
      },
    ];

    for (const paymentType of PaymentTypeStatus) {
      tabs.push({
        title: TimeMaterialService.getPaymentTypeStatusTitle(paymentType),
        component: BillsListViaType,
        props: { type: paymentType, bloc },
        visible: true,
      });
    }

    return tabs;
  }, []);

  const handleTabChange = useCallback(
    (index: number) => {
      const paymentTypeStatus = filterTabs[index]?.props?.type || 'all';
      bloc.paginated.patchQuery({ ...formValue, paymentTypeStatus, page: 1 }).subscribe();
    },
    [filterTabs, formValue],
  );
  return (
    <CBody>
      <Tabs tabs={filterTabs} onChange={handleTabChange} pills={true} simple={true} />
    </CBody>
  );
});
